module.exports = __webpack_public_path__ + "img/tab_button_img5_mobile.25f3ab29.png";